
namespace appn.ui.formulabuilder {
    // keep track of the current formula we're editing in all its states
    export let currentFormula: string | null = null;
    export let editedFormula = appn.emptyString;
    export let lastvalidatedFormula = appn.emptyString;

    // keep track of the current line we're editing
    export let editedLine = appn.emptyString;

    // keep track of the current mode of the formula builder
    export let currentMode: any = null;

    // specify an optional getter for fields dropdown
    export let fieldsLoad: any = null;

    // specify an optional getter for evaluation context JSON
    export let evaluationContextLoad: any = null;

    // callback for when formula is updated
    export let formulaUpdated: any = null;

    // keep track of the current designerJson
    export let designerJson: string | null = null;

    // keep track of the control name for validation error messages
    export let controlName: string | null = null;

    // keep track of the input
    export let $input: any = null;

    export let isFormula = false;

    export let structuredTextMode: any = undefined;

    export let requiresDesignerJson : boolean = false;
    export let screenId: string | null = null;

    // keep track of some elems at namespace level for fast access
    let $dialog: JQuery<HTMLElement>,
        $heading: JQuery<HTMLElement>,
        $formulaFieldsSelect: JQuery<HTMLElement>,
        $formulaFunctionsSelect: JQuery<HTMLElement>;
    export let editor: any;

    // method to call on modal show
    export function showDialog(sandbox: boolean = false) {
        prepare();

        if (!sandbox)
            $('#formulaDialog').modal('show');

        populate();

        // Reset AI conversation for new session
        currentAiConversation = [];
        currentHistorySignature = null;
        $('#formulaAiMessages').empty();
        $('#formulaAiPanel').data('initialized', false);  // Reset initialization flag
        $('#formulaAiPanel').hide();
        $('.ai-toggle-btn').removeClass('active');
    }

    // lazy assign fast access elems and hook dialog events if not already done so
    var prepare = function() {
        if (editor)                 // prepare has already been called before in this instance
            return;

        $dialog = $('#formulaDialog');
        $heading = $('#formulaDialog #myModalLabel-formulaDialog');
        $formulaFieldsSelect = $dialog.find('#formulaFields');
        $formulaFunctionsSelect = $dialog.find('#formulaFunctions');

        editor = appn.codeMirror.applyToTextArea('#formula', window.appn.codeMirror.codeTypes.formulaBuilder);

        $('#formulaBuilderEvaluate').on('click', function () {
            evaluateFormula();
        });

        // dialog events
        $dialog.find('#formulaBuilderApply').click(function(event) {
            event.preventDefault();
            event.stopPropagation();

            if (formulaUpdated)
                formulaUpdated(editor.getValue());

            currentFormula = editor.getValue();
            editor.setValue('');

            setTimeout(function() {
                editor.refresh();
            }, 250);

            $('#formulaDialog').modal('hide');
        });

        $dialog.find('#formulaBuilderValidate').click(function(event) {
            currentFormula = editor.getValue();
            validateFormula(true);
        });

        $dialog.find('#formulaBuilderEvaluate').click(function(event) {
            currentFormula = editor.getValue();
            evaluateFormula();
        });

        $dialog.on('hidden.bs.modal', function() {
            editor.setValue('');
            enableElement($('#formulaBuilderValidate'));
            SetMessageFor($('#validationSuccess'), appn.emptyString, false);
            SetMessageFor($('#validationError'), appn.emptyString, false);
            $('#evaluationResult').val('');
            $('#evaluationResultContainer').hideElement();
            SetMessageFor($('#formulaInfoCard'), T('When typing, use the TAB key to search and autocomplete formula function names'), true);
            setTimeout(function() {
                editor.refresh();
            }, 250);
        });

        $dialog.on('fullscreenToggled', function() {
            setTimeout(function() {
                editor.refresh();
            }, 100);
        });
    }

    export let insertIntoFormulaBox = function(selectedVal, replaceAll? : boolean, enableValidate? : boolean) {
        if (replaceAll)
            editor.setValue("");

        var doc = editor.getDoc();
        var cursor = doc.getCursor();
        doc.replaceRange(selectedVal, cursor);

        if (enableValidate)
            enableElement($('#formulaBuilderValidate'));
    };

    export let evaluateFormula = function() {
        const resultContainer = $('#evaluationResultContainer');
        const resultBox = $('#evaluationResult');
        const evaluateButton = $('#formulaBuilderEvaluate');

        if (!currentFormula || currentFormula.trim().length === 0) {
            resultBox.val(T('Please enter a formula to evaluate.'));
            resultContainer.showElement();
            return;
        }

        disableElement(evaluateButton);
        resultBox.val(T('Evaluating...'));
        resultContainer.showElement();

        const contextJson = evaluationContextLoad ? evaluationContextLoad() : null;

        appn.ajax.post({
            url: appn.urls.root + 'Syncs/Evaluate',
            data: {
                formula: currentFormula,
                contextJson: contextJson,
                isFormula: isFormula
            },
            dataType: 'json',
            done: function (response) {
                enableElement(evaluateButton);
                if (response.success) {
                    resultBox.val(response.result);
                } else {
                    resultBox.val(T('Error: {0}', response.message));
                }
            },
            fail: function() {
                enableElement(evaluateButton);
                resultBox.val(T('Evaluation request failed.'));
            }
        });
    };

    export let validateFormula = function(formulaBuilder) {

        // Check if formula has local error
        var hasLocalError = false;
        if ($input && !formulaBuilder) {
            var $inputContainer = $input.closest('li');
            hasLocalError = $inputContainer.hasClass('has-error') && !$inputContainer.hasClass('has-error-remote');

            // Remove current remote errors
            if (!hasLocalError) {
                $inputContainer.removeClass('error has-error has-error-remote');
                $inputContainer.find('.errorList').remove();
            }
        }

        const check = requiresDesignerJson
            ? Boolean(currentFormula && (designerJson || screenId))
            : Boolean(currentFormula);

        const successContainer = $('#validationSuccess');
        const errorContainer = $('#validationError');
        const infoContainer = $('#formulaInfoCard');
        const validateButton = $('#formulaBuilderValidate');

        if (!check) {
            // If we don't have a formula or the required data, we don't need to validate
            // However, we still need to give a visual cue to the user
            disableElement(validateButton); // We make sure to disable the button to stop spam
            SetMessageFor(successContainer, appn.emptyString, false);
            SetMessageFor(errorContainer, 'Could not validate the formula, please save the page to see if the formula is valid', true);
            $('.CodeMirror').removeClass('error');
        }

        const localIsFormula = isFormula !== null || isFormula !== undefined ? isFormula : true;
        var data = {
            formula: currentFormula,
            controlName: controlName,
            designerJson: designerJson,
            isFormula: localIsFormula,
            possibleStructuredTextMode: structuredTextMode,
            screenId: screenId
        };
        appn.ajax.post({
            url: appn.urls.root + 'Forms/ValidateFormula',
            data: data,
            dataType: 'json',
            done: function (response) {
                $('.validationWarningMessage').html('');
                if (response.msgType === 'warning') { // Validation fails
                    if (formulaBuilder) {
                        // Code mirror dialog
                        disableElement(validateButton); // We make sure to disable the button to stop spam
                        SetMessageFor(successContainer, appn.emptyString, false);
                        SetMessageFor(infoContainer, 'When typing, use the TAB key to search and autocomplete formula function names', false);
                        SetMessageFor(errorContainer, response.message, true);
                        $('.CodeMirror').addClass('error');
                        lastvalidatedFormula = editedFormula; // Keep track of what we have validated
                        // add tooltip and inint appn.tooltip.init()
                    } else if ($inputContainer && !hasLocalError) {
                        // Input in properties pane
                        $input.closest('li').addClass('error has-error has-error-remote');
                        $('<ul/>')
                            .addClass('errorList list-unstyled')
                            .append('<li>' + response.message + '</li>')
                            .appendTo($inputContainer);
                        $input.closest('.input-group').attr('data-validationstate', 'error');
                    }
                } else { // Validation succeeds
                    if (formulaBuilder) {
                        disableElement(validateButton); // We make sure to disable the button to stop spam
                        SetMessageFor(errorContainer, appn.emptyString, false);
                        SetMessageFor(infoContainer, 'When typing, use the TAB key to search and autocomplete formula function names', false);
                        SetMessageFor(successContainer, 'Formula is valid', true);
                        $('.CodeMirror').addClass('valid');
                        lastvalidatedFormula = editedFormula; // Keep track of what we have validated
                    } else if ($inputContainer && !hasLocalError) {
                        $inputContainer.removeClass('error has-error has-error-remote');
                        $inputContainer.find('.errorList').remove();
                        $input.closest('.input-group').attr('data-validationstate', 'success');
                    }

                    if ((window as any).isSandbox)
                        (window as any).activateCalculateButton();
                }
            },
            fail: function() {
                if (formulaBuilder) {
                    disableElement(validateButton); // We make sure to disable the button to stop spam
                    SetMessageFor(successContainer, appn.emptyString, false);
                    SetMessageFor(errorContainer, 'Could not validate the formula, please save the page to see if the formula is valid', true);
                    $('.CodeMirror').removeClass('error');
                }
            }
        });
    };

    // This populates the error and success cards below the editor
    function SetMessageFor(element, message, isVisible) {
        const container = element.find('.card-title');
        const htmlContent = container.html();
        const icon = htmlContent.substring(0, htmlContent.indexOf('</i>') + 4);
        container.html(`${icon}<span class="h6 mb-0">${message}</span>`);
        if (isVisible)
            element.showElement();
        else
            element.hideElement();
    } 

    // injector
    var populate = function() {
        if (appn.utils.hasValue(structuredTextMode))
            appn.codeMirror.setFormulaBuilderStructuredConfig(editor);

        editor.clearHistory();
        editor.setOption('template', currentMode === 'template');

        if (currentFormula) {
            editor.setValue(currentFormula);

            setTimeout(function() {
                editor.refresh();
            }, 250);
        } else {
            currentFormula = null;
            editor.setValue('');

            setTimeout(function() {
                editor.refresh();
            }, 250);
        }
        
        // Hide the field container since formula fields are not supported
        if (currentMode === "formulaOnly"){
            $formulaFieldsSelect.closest('div').hideElement();
        } else {
            // Ensure the container is shown, as it may have been hidden in the DS settings page
            $formulaFieldsSelect.closest('div').showElement();
            
            // build options for formulaFields.
            // if fields are empty, then attempt to populate from designer.data (if available)
            if ($formulaFieldsSelect.children('option:not(:first)').length === 0 && fieldsLoad) {
                $formulaFieldsSelect.children('option:not(:first)').remove();
                fieldsLoad($formulaFieldsSelect);
            }

            var ignoreInitialSelect = true;
            $formulaFieldsSelect.children('option:first').attr('selected', 'selected');

            appn.select.destroy('#formulaFields');
            $('#formulaFields').off('select2:select');

            appn.select.init({
                selector: '#formulaFields',
                onSelectCallback: function (e) {
                    const data = e.params.data;
                    if (ignoreInitialSelect)
                        return;
                    var selectedVal = data.id;
                    if (selectedVal === '')
                        return;
                    selectedVal = '{{' + selectedVal + '}}';
                    insertIntoFormulaBox(selectedVal);
                    $formulaFieldsSelect.val(appn.emptyString);
                    $formulaFieldsSelect.trigger('change');
                }
            });
        }

        // Grabbing the Property Title of the field For the Formula/Text Builder, Screen Name & Checking for Form Screen when necessary.
        // Default fields do not have an attribute field-name anymore, so if it is undefined we must grab and trim the ID
        var formulaPropTitle = $input?.data('field-name') ?? $input?.attr('id')?.replace('property_', '');
        var designerCheck = ui.designerAreaCheck();
        var icon = '<i class=\"fa fa-hammer\"></i>';
        var badge = $('<span class="badge badge-info ml-2 font-weight-light"></span>');

        const currentDesignerCheck = ui.designerAreaCheck();
        const evalContextAllowed = evaluationContextLoad || currentDesignerCheck.isSync;
        if (evalContextAllowed) {
            $dialog.find('#evaluateButton').showElement();
            $dialog.find('#validateButton').hideElement();
        }
        else {
            $dialog.find('#evaluateButton').hideElement();
            $dialog.find('#validateButton').showElement();
        }

        // show/hide functions select based on mode
        if (currentMode === 'fieldsOnly' ||
            currentMode === 'uitext') {
            $dialog.find('#formulaFunctions').hideElement();
            $dialog.find('.formulaFields-right-dropdown').hideElement();
            if (designerCheck.type === ScreenType.form)
                $heading.html(`${icon}Text Builder${(badge.text(`Field: ${controlName}`)).prop('outerHTML')}${(badge.text(formulaPropTitle === undefined ? emptyString : `Property: ${formulaPropTitle}`)).prop('outerHTML')}`);
            else
                $heading.html(`${icon}Text Builder`);

            appn.select.destroy('#formulaFunctions');
            $('#formulaFunctions').off('select2:select');

            appn.select.init({
                selector: '#formulaFunctions'
            });
        } else {
            var designerJsonObj = JSON.parse(designerJson as string);
            if (currentMode === 'template') {
                if (designerCheck.type === ScreenType.form)
                    $heading.html(`${icon}Text Builder${(badge.text(controlName === undefined ? `Screen: ${designerJsonObj.title}` : `Field: ${controlName}`)).prop('outerHTML')}${(badge.text(formulaPropTitle === undefined ? emptyString : `Property: ${formulaPropTitle}`)).prop('outerHTML')}`);
                else
                    $heading.html(`${icon}Text Builder`);
            } else {
                if (designerCheck.type === ScreenType.form)
                    $heading.html(`${icon}Formula Builder${(badge.text(controlName === undefined ? `Screen: ${designerJsonObj.title}` : `Field: ${controlName}`)).prop('outerHTML')}${(badge.text(formulaPropTitle === undefined ? emptyString : `Property: ${formulaPropTitle}`)).prop('outerHTML')}`);
                else
                    $heading.html(`${icon}Formula Builder`);
                isFormula = true;
            }

            $dialog.find('#formulaFunctions').showElement();
            $dialog.find('.formulaFields-right-dropdown').showElement();
            
            $formulaFunctionsSelect.children('option:first').attr('selected', 'selected');

            appn.select.destroy('#formulaFunctions');
            $('#formulaFunctions').off('select2:select');

            appn.select.init({
                selector: '#formulaFunctions',
                onSelectCallback: function(e) {
                    const data = e.params.data;
                    if (ignoreInitialSelect)
                        return;
                    var selectedVal = data.id;
                    if (selectedVal === '')
                        return;
                    if (currentMode === 'template')
                        selectedVal = '{( ' + selectedVal + ' )}';
                    insertIntoFormulaBox(selectedVal);
                    $formulaFunctionsSelect.val(appn.emptyString);
                    $formulaFunctionsSelect.trigger('change');
                }
            });
        }
        ignoreInitialSelect = false;

        // required in order to get content loading in editor
        setTimeout(function() {
            editor.refresh();
            editor.focus();
        }, 150);

        var targetNode = $('.CodeMirror .CodeMirror-code'); // Observe only the code editor to speed up the reaction time

        var mutationObserver = window.MutationObserver;
        var observer = new mutationObserver(mutationHandler);
        var obsConfig = {
            childList: true,
            characterData: true,
            attributes: true,
            subtree: true,
            attributeOldValue: true,
            characterDataOldValue: true
        };
        targetNode.each(function() {
            observer.observe(this, obsConfig);
        });

        var designerCheck = ui.designerAreaCheck();
        // Only display comments for Formula builder and only for Form design
        if (designerCheck.isDesigner && designerCheck.type === ScreenType.form)
            prepareCommentHeader();
    };

    function mutationHandler(mutationList, observer) {
        $('.CodeMirror').removeClass('error');
        $('.CodeMirror').removeClass('valid');

        // Remove mutations that impeded our ability to check code changes
        const mutations = mutationList.filter((o, i, a) => {
            return (
                $(o.target).attr('class')?.indexOf('CodeMirror-cursors') === -1 &&
                $(o.target).attr('class')?.indexOf('CodeMirror-measure') === -1 &&
                $(o.target).attr('class')?.indexOf('CodeMirror-code') === -1
            );
        });

        const validateButton = $('#formulaBuilderValidate');
        editedFormula = editor.getValue();

        // Make sure the mutation in question is a valid mutation
        if (mutations.length === 0) {
            observer.takeRecords();
            if (editedFormula.trim().length === 0)
                disableElement(validateButton);

            return;
        }

        // Check if line value was changed or just navigated
        const lineText = mutations[0].target.innerText;
        if (editedLine !== appn.emptyString) {
            if (editedLine === lineText)
                return;
        }

        editedLine = lineText;
        const check = requiresDesignerJson ? Boolean(designerJson || screenId) : true

        if (check
            && editedFormula.trim().length > 0
            && editedFormula.trim() !== lastvalidatedFormula
            && (currentFormula !== editedFormula.trim() || currentFormula !== lastvalidatedFormula.trim())) {
            enableElement(validateButton);
            currentFormula = editedFormula;
        }
        else
            disableElement(validateButton); // Disable if they just add a space, navigate around, they already tried this formula

        SetMessageFor($('#formulaInfoCard'), 'When typing, use the TAB key to search and autocomplete formula function names', true);
        SetMessageFor($('#validationError'), appn.emptyString, false);
        SetMessageFor($('#validationSuccess'), appn.emptyString, false);
    }

    function enableElement(element) {
        const classesString = element.attr('class');
        const classes = classesString.split(' ').filter((o, i, a) => { return o.length > 0 && o.indexOf('disabled') === -1 }); // Strip empties and disables
        element.attr('class', classes.join(' '));
    }

    function disableElement(element) {
        const classesString = element.attr('class');
        const classes = classesString.split(' ').filter((o, i, a) => { return o.length > 0 }); // Strip empties and disables
        classes.push('disabled');
        element.attr('class', classes.join(' '));
    }

    // Code Comment Section
    function prepareCommentHeader() {
        const dialogHeader = $('#myModalLabel-formulaDialog').text();
        const headerRow = $('.formula-dialog-increased-height .card-body .builder-controls');
        const commentContainer = headerRow.find('#commentButton');

        if (dialogHeader.includes('Formula')) {
            setCommentControls(commentContainer);

            return;
        }

        resetCommentControls(commentContainer);
    }

    function setCommentControls(comment) {
        if (!comment.hasClass('d-none'))
            return;

        comment.removeClass('d-none');

        addCommentEvents();
    }

    function resetCommentControls(comment) {
        if (comment.hasClass('d-none'))
            return;

        comment.addClass('d-none');

        removeCommentEvents();
    }

    function addCommentEvents() {
        $('#commentButton').off().on('click', function() {
            if (editor.somethingSelected()) {
                // Comment selection <- does not style
                var selectionFrom = editor.getCursor('from');
                var selectionTo = editor.getCursor('to');

                var from = { line: selectionFrom.line, ch: selectionFrom.ch };
                var to = { line: selectionTo.line, ch: selectionTo.ch };

                var firstLineText = editor.getLine(from.line);

                if (firstLineText.indexOf('/*') > -1) {
                    editor.uncomment(from, to);
                    return;
                }

                editor.blockComment(from, to);
            } else {
                // New comment line <- does not style
                var cursor = editor.getCursor();
                editor.setSelection(cursor);
                editor.replaceSelection('/* Add comments here */');
            }
        });
    }
    function removeCommentEvents() {
        $('#commentButton').off();
    }

    // AI Assistant state
    export let aiAssistantUrl: string | null = null;
    export let currentAiConversation: any[] = [];
    export let currentHistorySignature: string | null = null;
    export let formulaMode: string = '';

    export function initAi(url: string, mode?: string) {
        aiAssistantUrl = url;
        formulaMode = mode || '';
        $('.ai-toggle-btn').show();

        const helloMessageTemplate = T(`Hi there! Need some help with building your formula? Simply tell me what you need!`);

        $('.ai-toggle-btn').off('click').on('click', function (e) {
            e.preventDefault();
            const $panel = $('#formulaAiPanel');
            const $messages = $('#formulaAiMessages');
            // Force hide tooltip
            $(this).tooltip('hide');

            // Initialize hello message on first open
            if (!$panel.data('initialized')) {
                const sender = '<span class="text-purple"><i class="fas fa-sparkles"></i> AI</span>';
                const helloHtml = `
                    <div class="ai-message-wrapper text-left mb-2">
                        <div class="ai-message d-inline-block p-2 rounded" style="max-width: 60%; text-align: left;">
                            <div class="small font-weight-bold mb-1">${sender}</div>
                            <div class="ai-message-content small text-dark">${helloMessageTemplate}</div>
                        </div>
                    </div>
                `;
                $messages.html(helloHtml);
                $panel.data('initialized', true);
            }
            $panel.slideToggle();
            $(this).toggleClass('active');
        });
        $('#formulaAiSend').off('click').on('click', function (e) {
            e.preventDefault();
            sendAiPrompt();
        });

        $('#formulaAiInput').off('keypress').on('keypress', function (e) {
            if (e.which === 13 && !e.shiftKey) {
                e.preventDefault();
                sendAiPrompt();
            }
        });

        appn.infer.hookSpeechToText($('#formulaAiPanel .prompt-speech'), $('#formulaAiInput'));
        appn.infer.setupAutoInputGrow($('#formulaAiInput'));
    }

    function sendAiPrompt() {
        const $input = $('#formulaAiInput');
        const prompt = $input.val() as string;

        if (!prompt || prompt.trim().length < 10) {
            appn.toast.notify(appn.toast.Type.error, T('A minimum of 10 characters is required for AI assistance.'));
            return;
        }

        const $messages = $('#formulaAiMessages');
        const $sendBtn = $('#formulaAiSend');

        // Add user message to UI
        addAiMessage('user', prompt);
        $input.val('').trigger('input');

        // Show loading
        const $loading = $(`<div class="ai-loading mb-2 small text-muted"><i class="fas fa-sparkles fa-spin mr-1"></i> ${T('Thinking...')}</div>`);
        $messages.append($loading);
        $messages.scrollTop($messages.prop('scrollHeight'));
        $sendBtn.prop('disabled', true);

        // Prepare context
        const fields: any[] = [];
        $formulaFieldsSelect.find('option:not(:first)').each((_, opt) => {
            fields.push({ value: $(opt).val(), text: $(opt).text() });
        });

        const contextJson = evaluationContextLoad ? evaluationContextLoad() : null;

        appn.ajax.post({
            url: aiAssistantUrl || '',
            dataType: 'json',  // Ensure response is parsed as JSON
            data: {
                prompt: prompt,
                conversationJson: JSON.stringify(currentAiConversation),
                mode: formulaMode,
                currentFormula: editor.getValue(),
                fieldsJson: JSON.stringify(fields),
                contextJson: contextJson ? JSON.stringify(contextJson) : null,
                historySignature: currentHistorySignature
            },
            done: function (data) {
                // Handle case where response comes as string
                const responseObj = typeof data === 'string' ? JSON.parse(data) : data;
                $loading.remove();
                if (responseObj.success && responseObj.response) {
                    currentHistorySignature = responseObj.historySignature;
                    const response = responseObj.response;

                    // Build message content with formula and explanation
                    let messageContent = '';
                    if (response.formulaCode) {
                        // Escape the formula code for HTML
                        const safeFormula = response.formulaCode
                            .replace(/&/g, "&amp;")
                            .replace(/</g, "&lt;")
                            .replace(/>/g, "&gt;")
                            .replace(/\n/g, "<br>");
                        messageContent += `<pre class="mb-2 p-2 bg-dark text-light rounded small" style="font-family: monospace;">${safeFormula}</pre>`;
                    }
                    // Escape and add explanation
                    const safeExplanation = response.explanation
                        .replace(/&/g, "&amp;")
                        .replace(/</g, "&lt;")
                        .replace(/>/g, "&gt;")
                        .replace(/\n/g, "<br>");
                    messageContent += `<div class="ai-message-content">${safeExplanation}</div>`;

                    // Add AI message to UI
                    const aiMsg = addAiMessage('model', '');

                    // Set the message content directly
                    aiMsg.find('.ai-message-content').html(messageContent);

                    // Add Apply button if formula exists
                    if (response.formulaCode) {
                        const $applyBtn = $(`<button class="btn btn-xs btn-outline-purple mt-2">${T('Apply Formula')}</button>`);
                        $applyBtn.on('click', function () {
                            editor.setValue(response.formulaCode);
                            lastvalidatedFormula = ''; // Force re-validation
                            enableElement($('#formulaBuilderValidate'));
                        });
                        aiMsg.find('.ai-message').append($applyBtn);
                    }

                    // Update conversation history (Option B: only keep in memory for current session)
                    currentAiConversation.push(...responseObj.turns);
                } else if (responseObj.ErrorType === "usage_limit_exceeded") {
                    addAiMessage('model', `${responseObj.Message}. ${T('Please upgrade your plan.')}`);
                } else {
                    addAiMessage('model', responseObj.Message || T('Failed to get a response from AI.'));
                }
            },
            fail: function () {
                $loading.remove();
                addAiMessage('model', T('Failed to communicate with the server.'));
            },
            always: function () {
                $sendBtn.prop('disabled', false);
            }
        });
    }

    function addAiMessage(role: string, text: string) {
        const $messages = $('#formulaAiMessages');
        const sender = role === 'user' ? T('You') : '<span class="text-purple"><i class="fas fa-sparkles"></i> AI</span>';
        const alignment = role === 'user' ? 'text-right' : 'text-left';

        const safeText = text.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br>");

        const html = `
            <div class="ai-message-wrapper ${alignment} mb-2">
                <div class="ai-message d-inline-block p-2 rounded" style="max-width: 60%; text-align: left;">
                    <div class="small font-weight-bold mb-1">${sender}</div>
                    <div class="ai-message-content small text-dark">${safeText}</div>
                </div>
            </div>`;

        const $msg = $(html);
        $messages.append($msg);
        $messages.scrollTop($messages.prop('scrollHeight'));
        return $msg;
    }
}

